export function serialize(record) {
  return JSON.stringify(record);
}

export function deserialize(json) {
  const {
    additional_dues,
    advice,
    budget_classification,
    certification,
    classification_certificate,
    code,
    comments,
    notes,
    classification_comments,
    customs_laboratoris,
    description,
    dual_use_goods,
    duty,
    free_trade_zone_agreements,
    duty_sng,
    excise_dues,
    excise_duty_marks,
    export_dues,
    filling_instruction,
    licence,
    ondate,
    quota,
    short_description,
    tariff_preference,
    unit_name,
    vat,
    to_date,
    id,
    parent,
    tnved
  } = json;

  return {
    additional_dues,
    advice,
    budget_classification,
    certification,
    classification_certificate,
    code,
    comments,
    notes,
    classification_comments,
    customs_laboratoris,
    description,
    dual_use_goods,
    duty,
    free_trade_zone_agreements,
    duty_sng,
    excise_dues,
    excise_duty_marks,
    export_dues,
    filling_instruction,
    licence,
    ondate,
    quota,
    short_description,
    tariff_preference,
    unit_name,
    vat,
    to_date,
    id,
    parent,
    tnved
  }
}



// WEBPACK FOOTER //
// ./src/serializers/EtsngCode.js